import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import constClass from '../../Constants/Constants';
import { useToasts } from 'react-toast-notifications';
import { useParams } from 'react-router';
import Constants from '../../Constants/Constants';
import Select from 'react-select';

const Schedule = (props) => {
  const { user } = props
  const [lockData, setLockData] = useState(false);
  const { siteId, mallId } = useParams();
  const { addToast } = useToasts();

  const [values, setValues] = useState({
    site_id: siteId, 
    mall_id: mallId, 
    schedule_id: null, 
    schedule_name: '', 
    schedule_type: '',
    start_date: '',
    end_date: '',
    weekdays: [],
    start_time: '',
    end_time: '',
    upd_date: null, 
  });

  const PAGE_SIZE = 5;
  const [scheduleData, setScheduleData] = useState(null);
  const [searchKeyword, setSearchKeyword] = useState(''); 
  const [currentPage, setCurrentPage] = useState(1);

  const refreshSchedule = useCallback(async () => {
    const jwt = localStorage.getItem('jwt');

    console.log("refreshSchedule");
    // スケジュールマスタ
    const scheduleData = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/schedule/search/`, { site_id: siteId, mall_id: mallId }, {
      headers: {
        Authorization: `Bearer ${jwt}`,
      }
    })).data;
    setScheduleData(scheduleData);
  }, [siteId, mallId])

  // 登録ボタン：処理
  const handleRegistClick = async (data) => {
    const jwt = localStorage.getItem('jwt');
    //重複チェック
    if (data.schedule_name === '' || data.schedule_name === null) {
      window.alert('スケジュール名を入力してください。');
      return;
    }
    if (data.schedule_type === "" || data.schedule_type === null) {
      window.alert('スケジュール区分を選択してください。');
      return;
    }
    if (data.schedule_type === "0") {
      if (data.weekdays.length === 0) {
        window.alert('適用曜日を選択してください。');
        return;
      }
    }
    if (data.schedule_type === "1") {
      if (data.start_date) {
        if (!(/^\d+$/.test(data.start_date)) || !((parseInt(data.start_date, 10) >= 1 && parseInt(data.start_date, 10) <= 31))) {
          window.alert('開始日は1～31の半角整数で入力してください。');
          return; 
        }
      } else {
        window.alert('開始日を入力してください。');
        return;
      }
      if (data.end_date) {
        if (!(/^\d+$/.test(data.end_date)) || !((parseInt(data.end_date, 10) >= 1 && parseInt(data.end_date, 10) <= 31))) {
          window.alert('終了日は1～31の半角整数で入力してください。')
          return;
        }
      } else {
        window.alert("終了日を入力してください。");
        return;
      }
    }
    if (!data.start_time) {
      window.alert('開始時間を入力してください。');
      return;
    }
    if (!data.end_time) {
      window.alert('終了時間を入力してください。');
      return;
    }
    if (data.start_time) {
      if (!(/^\d+$/.test(data.start_time)) || !((parseInt(data.start_time, 10) >= 0 && parseInt(data.start_time, 10) <= 23))) {
        window.alert('開始時間は0～23の半角整数で入力してください。');
        return; 
      }
    }
    if (data.end_time) {
      if (!(/^\d+$/.test(data.end_time)) || !((parseInt(data.end_time, 10) >= 0 && parseInt(data.end_time, 10) <= 23))) {
        window.alert('終了時間は0～23の半角整数で入力してください。')
        return;
      }
      if (parseInt(data.start_time, 10) >= parseInt(data.end_time, 10)) {
        window.alert('終了時間は開始時間以降の時間を入力してください。')
        return;
      }
    }

    if (!window.confirm(`登録してよろしいですか？`)) {
      return;
    }

    if (data.schedule_type) {
      if (data.schedule_type === "0") {
        data.start_date = null;
        data.end_date = null;
      } else {
        data.weekdays = [];
      }
    } else {
      data.start_date = null;
      data.end_date = null;
      data.weekdays = [];
    }

    const params = {
      site_id: siteId,
      mall_id: mallId,
      schedule_id: data.schedule_id,
      schedule_name: data.schedule_name ? data.schedule_name : null,
      schedule_type: data.schedule_type ? data.schedule_type : null,
      start_date: data.start_date ? data.start_date : null,
      end_date: data.end_date ? data.end_date : null,
      weekdays: data.weekdays.length > 0 ? data.weekdays : null,
      start_time: data.start_time ? data.start_time : null,
      end_time: data.end_time ? data.end_time : null,
      upd_name: user.userId,
      upd_date: data.upd_date
    };
    let res;
    try {
      setLockData(true);
      res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/schedule/`, params, {
        headers: {
          Authorization: `Bearer ${jwt}`,
        }
      });
    } catch (err) {
      console.log(err);
      if (err.response.data !== null) {
        addToast(err.response.data.message, { appearance: 'error', autoDismiss: true });
      } else {
        addToast(err.response, { appearance: 'error', autoDismiss: true });
      }
    } finally {
      if (!res) {
      } else if (res.data.error) {
        addToast(res.data.message, { appearance: 'error', autoDismiss: true });
      } else {
        addToast('登録しました。', { appearance: 'success', autoDismiss: true });
        await refreshSchedule();
      }
      setLockData(false);
      handleResetClick();
    }
  }

  /* 編集ボタン押下 */
  const handleUpdateClick = (data) => {
    setValues({
      ...data,
      weekdays: data.weekdays ? data.weekdays : [],
      edit_flag: constClass.FLAG.ON
    });
  }

  /* RESETボタン押下 */
  const handleResetClick = () => {
    setValues({
      site_id: siteId,
      mall_id: mallId,
      schedule_id: null,
      schedule_name: "",
      schedule_type: "",
      start_date: "",
      end_date: "",
      weekdays: [],
      start_time: "",
      end_time: "",
      upd_date: null,
      edit_flag: constClass.FLAG.OFF,
    });
  }
  
  const renderUpdateButton = (data) => {
    return (
      <button
        className={`btn btn-primary mx-1`}
        onClick={() => handleUpdateClick(data)}>
        編集
      </button>
    )
  }

  const renderRegistButton = (data) => {
    return (
      <button type="button"
        disabled={lockData || data.user_name === ''}
        className={`btn btn-primary mx-1 w-50`}
        onClick={() => handleRegistClick(data)}>
        登録
      </button>
    )
  }

  const renderDeleteButton = (data) => {
    return (
      <button type="button"
        disabled={lockData || data.schedule_id === null || data.schedule_id === ''}
        className={`btn btn-primary mx-1 w-50`}
        onClick={() => handleDeleteClick(data)}>
        削除
      </button>
    )
  }

  const renderResetButton = () => {
    return (
      <button type="button"
        disabled={false}
        className={`btn btn-primary mx-1 w-50`}
        onClick={() => handleResetClick()}>
        リセット
      </button>
    )
  }

  // 削除ボタン：処理
  const handleDeleteClick = async (data) => {
    const jwt = localStorage.getItem('jwt');
    var targetSchedule;
    try {
      targetSchedule = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/schedule/search/Id`, {site_id: siteId, mall_id: mallId, schedule_id: data.schedule_id}, {
        headers: {
          Authorization: `Bearer ${jwt}`,
        }
      })).data;
    } catch (err) {
      if (err.response.data !== null) {
        addToast(err.response.data.msg, { appearance: 'error', autoDismiss: true });
      } else {
        addToast(err.response, { appearance: 'error', autoDismiss: true });
      }
    }
    var linkedPointCampaign = targetSchedule.m_point_campaign;
    var linkedCheckinPointCampaign = targetSchedule.m_checkin_point_campaign;
    var linkedAppLottery = targetSchedule.m_app_lottery;
    var linkedTicket = targetSchedule.m_ticket;
    if (!window.confirm(`スケジュール[${data.schedule_id}:${data.schedule_name}]を削除します。よろしいですか？`)) {
      return;
    }

    var warningMessage = '';
    if (linkedPointCampaign.length > 0) {
      warningMessage += 'キャンペーン：';
      linkedPointCampaign.forEach((campaign, index) => {
        warningMessage += `${campaign.point_campaign_name}${index === linkedPointCampaign.length - 1 ? '\n' : '、'}`;
      });
    }
    if (linkedCheckinPointCampaign.length > 0) {
      warningMessage += 'キャンペーン(チェックイン)：';
      linkedCheckinPointCampaign.forEach((campaign, index) => {
        warningMessage += `${campaign.point_campaign_name}${index === linkedCheckinPointCampaign.length - 1 ? '\n' : '、'}`;
      });
    }
    if (linkedAppLottery.length > 0) {
      warningMessage += '抽選：';
      linkedAppLottery.forEach((lottery, index) => {
        warningMessage += `${lottery.lottery_title}${index === linkedAppLottery.length - 1 ? '\n' : '、'}`;
      });
    }
    if (linkedTicket.length > 0) {
      warningMessage += 'クーポン：';
      linkedTicket.forEach((ticket, index) => {
        warningMessage += `${ticket.ticket_name}${index === linkedTicket.length - 1 ? '\n' : '、'}`;
      });
    }

    if (linkedPointCampaign.length > 0 || linkedCheckinPointCampaign.length > 0 || linkedAppLottery.length > 0 || linkedTicket.length > 0) {
      if (!window.confirm(`すでに設定済みのスケジュールを削除しようとしています。\n対象期間内の場合、スケジュールを削除すると即時開催となります。\nクーポンの場合は即時利用可能となります。\n本当によろしいですか？\n\n${warningMessage}`)) {
        return;
      }
    }
    const params = {
      site_id: siteId,
      mall_id: mallId,
      schedule_id: data.schedule_id,
      user_id: data.user_id,
      upd_date: data.upd_date
    };
    let res;
    try {
      setLockData(true);
      res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/schedule/delete/`, params, {
        headers: {
          Authorization: `Bearer ${jwt}`,
        }
      });
    } catch (err) {
      if (err.response.data !== null) {
        addToast(err.response.data.msg, { appearance: 'error', autoDismiss: true });
      } else {
        addToast(err.response, { appearance: 'error', autoDismiss: true });
      }
    } finally {
      if (res.data.error) {
        addToast(res.data.message, { appearance: 'error', autoDismiss: true });
      } else {
        addToast('削除しました。', { appearance: 'success', autoDismiss: true });
        await refreshSchedule();
      }
      setLockData(false);
      handleResetClick();
    }
  }

  const handleChange = (e) => {
    const target = e.target;
    var value = target.type === "checkbox" ? (target.checked ? constClass.FLAG.ON : constClass.FLAG.OFF) : target.value;
    const name = target.name;
    setValues({ ...values, [name]: value });
  }

  const handleWeekdayChange = (selectedOptions) => {
    const selectedValues = selectedOptions.map(option => option.value);
    const sortedValues = selectedValues.sort((a, b) => a - b);
    setValues({ ...values, weekdays: sortedValues });
  };

  const weekdays = [
    { value: 0, label: '日曜日' },
    { value: 1, label: '月曜日' },
    { value: 2, label: '火曜日' },
    { value: 3, label: '水曜日' },
    { value: 4, label: '木曜日' },
    { value: 5, label: '金曜日' },
    { value: 6, label: '土曜日' },
  ];


  // 初期実行トリガー
  useEffect(() => {
    async function fetchData() {
      await refreshSchedule();
    }
    return fetchData();
  }, [refreshSchedule]);

  const renderInput = () => {
    return (
      <div className="mx-1">
        <div className="row mb-3">
          <div className="col-2 text-center align-self-center">
            <label htmlFor="schedule_id">スケジュールID</label>
          </div>
          <div className="col-2 text-center align-self-center">
            <input type="text" className="form-control" name="schedule_id" defaultValue={values.schedule_id} placeholder="新規" readOnly />
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-2 text-center align-self-center">
            <label htmlFor="schedule_name">スケジュール名</label>
          </div>
          <div className="col-5 text-center align-self-center">
            <input type="text" className="form-control" id="schedule_name" name="schedule_name" value={values.schedule_name} onChange={handleChange} placeholder="スケジュール名を入力してください" />
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-2 text-center align-self-center">
            <label htmlFor="schedule_type">スケジュール区分</label>
          </div>
          <div className="col-2 text-center align-self-center">
            <select className="form-control" name="schedule_type" value={values.schedule_type} onChange={handleChange}>
              <option value="">- 選択 -</option>
              <option value="0">曜日</option>
              <option value="1">日付</option>
            </select>
          </div>
        </div>
        {values.schedule_type === Constants.SCHEDULE_TYPE.WEEKDAY && <div className="row mb-3">
          <div className="col-2 text-center align-self-center">
            <label htmlFor="weekday">適用曜日</label>
          </div>
          <div className="col-5 text-left align-self-center">
            <Select
              options={weekdays}
              isMulti
              closeMenuOnSelect={false}
              onChange={handleWeekdayChange}
              value={weekdays.filter(day => values.weekdays.includes(day.value))} // 選択された曜日を表示
              styles={{ container: (base) => ({ ...base, zIndex: 600 }) }}
              placeholder="- 選択 -" 
            />
          </div>
        </div>}
        {values.schedule_type === Constants.SCHEDULE_TYPE.DATE && <div className="row mb-3">
          <div className="col-2 text-center align-self-center">
            <label htmlFor="date">適用期間</label>
          </div>
          <div className="col-2 text-center align-self-center">
            <input type="text" className="form-control" id="start_date" name="start_date" value={values.start_date} onChange={handleChange} placeholder="開始日"/>
          </div>
          <div className='col-1 text-center'>～</div>
          <div className="col-2 text-center align-self-center">
            <input type="text" className="form-control" id="end_date" name="end_date" value={values.end_date} onChange={handleChange} placeholder="終了日"/>
          </div>
          <small className="form-text text-muted text-nowrap">※毎月の開始日、終了日を1～31の範囲でご入力ください。<br/>　月をまたぐ場合は開始日に今月、終了日に来月の日付をご入力ください。</small>
        </div>}
        <div className="row mb-3">
          <div className="col-2 text-center align-self-center">
            <label htmlFor="user_name">適用時間</label>
          </div>
          <div className="col-2 text-center align-self-center">
            <input type="text" className="form-control" id="start_time" name="start_time" value={values.start_time} onChange={handleChange} placeholder="開始時間"/>
          </div>
          <div className='col-1 text-center'>～</div>
          <div className="col-2 text-center align-self-center">
            <input type="text" className="form-control" id="end_time" name="end_time" value={values.end_time} onChange={handleChange} placeholder="終了時間"/>
          </div>
          <small className="form-text text-muted text-nowrap">※スケジュールの適用時間を0～23の範囲でご入力ください。</small>
        </div>
        <div className="row mb-2 pb-4">
          <div className="col-3 text-center">{renderRegistButton(values)}</div>
          <div className="col-3 text-center">{renderDeleteButton(values)}</div>
          <div className="col-3 text-center">{renderResetButton(values)}</div>
        </div>
      </div>
    );
  }

  const renderList = () => {
    const filteredData = scheduleData.filter(data =>
      !searchKeyword || data.schedule_name.includes(searchKeyword)
    );
    const totalPages = Math.ceil(filteredData.length / PAGE_SIZE);
    const pagedData = filteredData.slice((currentPage - 1) * PAGE_SIZE, currentPage * PAGE_SIZE);

    return (
      <div className="row mb-3  mt-3 p-0">
        <div className="col-12 mb-2">
          <div className="row">
            <input
              type="text"
              className="col-4 form-control"
              placeholder="スケジュール名で絞り込み"
              value={searchKeyword}
              onChange={e => { setSearchKeyword(e.target.value); setCurrentPage(1); }}
            />
          </div>
        </div>
        <div className="col-12 p-0">
          <div className="d-flex justify-content-between align-items-center mb-1">
            <span className="small text-muted">{filteredData.length}件中 {Math.min((currentPage - 1) * PAGE_SIZE + 1, filteredData.length)}〜{Math.min(currentPage * PAGE_SIZE, filteredData.length)}件表示</span>
            {totalPages > 1 && (
              <nav>
                <ul className="pagination pagination-sm mb-0">
                  <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                    <button className="page-link" onClick={() => setCurrentPage(p => p - 1)}>‹</button>
                  </li>
                  {Array.from({ length: totalPages }, (_, i) => i + 1).map(page => (
                    <li key={page} className={`page-item ${currentPage === page ? 'active' : ''}`}>
                      <button className="page-link" onClick={() => setCurrentPage(page)}>{page}</button>
                    </li>
                  ))}
                  <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                    <button className="page-link" onClick={() => setCurrentPage(p => p + 1)}>›</button>
                  </li>
                </ul>
              </nav>
            )}
          </div>
          <table className="table table-bordered table-striped">
            <thead className={`table-info`}>
              <tr>
                <td className="text-center align-middle">
                  スケジュールID
                </td>
                <td className="text-center align-middle">
                  スケジュール名
                </td>
                <td className="text-center align-middle">
                  処理
                </td>
              </tr>
            </thead>
            <tbody>
              {filteredData.length === 0 && <tr><td colSpan={3} className='text-center'>データがありません</td></tr>}
              {pagedData.map((data) => (
                <tr key={data.schedule_id}>
                  {/* スケジュールID */}
                  <td className="text-center align-middle">
                    {data.schedule_id}
                  </td>
                  {/* スケジュール名 */}
                  <td className="text-center align-middle">
                    {data.schedule_name}
                  </td>
                  {/* 処理 */}
                  <td className="text-center align-middle text-nowrap">
                    {renderUpdateButton(data)}
                  </td>
                </tr>
              ))
              }
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  return (
    <div className="container">
      {scheduleData === null && <div className="row"><div className="col-12">読み込み中・・・</div></div>}
      {scheduleData !== null && (renderList())}
      {scheduleData !== null && (renderInput())}
      {/* {renderPreview()} */}
    </div>
  )
}

export default Schedule;